/**
 * The room diagram: the ballroom's anchor grid with this event's rounds on it.
 *
 * Extracted out of the BEO board because the printed sheet in your hand has to
 * draw exactly the same picture. Two implementations of the same diagram is two
 * diagrams that disagree the first time the grid changes, and the entire skill
 * the game is testing is reading this thing and remembering it.
 *
 * Rows run top to bottom as increasing z, which is how the room reads walking in
 * from the service doors on the north wall — so the diagram is oriented the same
 * way the player will be.
 */
export function buildDiagram(setup, grid, { compact = false } = {}) {
  const wrap = document.createElement('div');
  wrap.className = 'diagram';
  wrap.style.setProperty('--cols', grid.cols);

  const wanted = new Set();
  const { col, row, cols, rows } = setup.layout;
  for (let c = col; c < col + cols; c += 1) {
    for (let r = row; r < row + rows; r += 1) wanted.add(`${c},${r}`);
  }

  const [kx0, kz0, kx1, kz1] = grid.keepClear;
  for (let r = 0; r < grid.rows; r += 1) {
    for (let c = 0; c < grid.cols; c += 1) {
      const cell = document.createElement('i');
      const x = grid.origin[0] + c * grid.spacing;
      const z = grid.origin[1] + r * grid.spacing;
      if (x >= kx0 && x <= kx1 && z >= kz0 && z <= kz1) cell.dataset.keep = 'clear';
      if (wanted.has(`${c},${r}`)) cell.dataset.set = 'table';
      wrap.append(cell);
    }
  }

  const box = document.createElement('div');
  box.className = 'diagram-box';
  box.append(wrap);

  if (!compact) {
    const key = document.createElement('div');
    key.className = 'diagram-key';
    key.innerHTML =
      '<span><i data-set="table"></i> round</span>' +
      '<span><i data-keep="clear"></i> dance floor: keep clear</span>' +
      '<span class="diagram-note">doors on the north wall, top of plan</span>';
    box.append(key);
  }

  return box;
}
